import React from "react";

export default function DeleteSuccess() {
  return (
    <div className="page1">You have successfully deleted your account.</div>
  );
}
